import { render, staticRenderFns } from "./registration-token-loader.vue?vue&type=template&id=e78f6872"
import script from "./registration-token-loader.vue?vue&type=script&lang=ts"
export * from "./registration-token-loader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports